import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Toolbar,
  Collapse,
  useTheme,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  People,
  Assignment,
  LocationOn as LocationOnIcon,
  Person as PersonIcon,
  ExpandLess,
  ExpandMore,
  Build as BuildIcon,
  Search as SearchIcon,
  Camera as CamIcon,
  Timer as TimerIcon,
  LocalShipping as LocalShippingIcon,
  LocalHospital as LocalHospitalIcon,
} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import BuscarPacienteModal from './BuscarPacienteModal';
import { CalendarIcon } from '@mui/x-date-pickers';

const drawerWidth = 240;

const Sidebar = ({ openSidebar, setOpenSidebar, userRole }) => {
  const [openDomicilio, setOpenDomicilio] = useState(false);
  const [openRecepcion, setOpenRecepcion] = useState(false);
  const [openBuscarPaciente, setOpenBuscarPaciente] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => setOpenSidebar(false);

  const esRol5 = userRole === 5;

  return (
    <Drawer
      variant={isMobile ? 'temporary' : 'persistent'}
      open={openSidebar}
      onClose={handleDrawerToggle}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          bgcolor: '#1e293b',
          color: '#fff',
        },
      }}
    >
      <Toolbar />
      <Divider sx={{ bgcolor: '#4b5563' }} />
      <List>

        {/* ==================== MENÚ PARA ROL 5 (Solo Domicilios) ==================== */}
        {esRol5 ? (
          <>
            {/* Domicilios - Única sección visible */}
            <ListItemButton onClick={() => setOpenDomicilio(!openDomicilio)}>
              <ListItemIcon><LocalShippingIcon sx={{ color: '#fff' }} /></ListItemIcon>
              <ListItemText primary="Domicilios" />
              {openDomicilio ? <ExpandLess sx={{ color: '#fff' }} /> : <ExpandMore sx={{ color: '#fff' }} />}
            </ListItemButton>
            <Collapse in={openDomicilio} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/ruta-programada">
                    <ListItemIcon><Assignment sx={{ color: '#fff' }} /></ListItemIcon>
                    <ListItemText primary="Ruta programada" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Collapse>
          </>
        ) : (
          /* ==================== MENÚ COMPLETO PARA OTROS ROLES ==================== */
          <>
            {/* Clientes */}
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/clientes">
                <ListItemIcon><PersonIcon sx={{ color: '#fff' }} /></ListItemIcon>
                <ListItemText primary="Clientes" />
              </ListItemButton>
            </ListItem>

            {/* Citas Calendario */}
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/citas/calendario">
                <ListItemIcon><CalendarIcon sx={{ color: '#fff' }} /></ListItemIcon>
                <ListItemText primary="Citas Calendario" />
              </ListItemButton>
            </ListItem>

            {/* Citas VISTA diaria citas */}
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/vistadiariacitas">
                <ListItemIcon><CalendarIcon sx={{ color: '#fff' }} /></ListItemIcon>
                <ListItemText primary="Vista Diaria Citas" />
              </ListItemButton>
            </ListItem>


            {/* Cámaras QR */}
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/camaras">
                <ListItemIcon><CamIcon sx={{ color: '#fff' }} /></ListItemIcon>
                <ListItemText primary="Camaras QR" />
              </ListItemButton>
            </ListItem>

            {/* Buscar Paciente */}
            <ListItem disablePadding>
              <ListItemButton onClick={() => setOpenBuscarPaciente(true)}>
                <ListItemIcon><SearchIcon sx={{ color: '#fff' }} /></ListItemIcon>
                <ListItemText primary="Buscar Paciente" />
              </ListItemButton>
            </ListItem>

            {/* Hospitalizados */}
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/hospitalizados-lista">
                <ListItemIcon><LocalHospitalIcon sx={{ color: '#fff' }} /></ListItemIcon>
                <ListItemText primary="Hospitalizados" />
              </ListItemButton>
            </ListItem>

            {/* Domicilios */}
            <ListItemButton onClick={() => setOpenDomicilio(!openDomicilio)}>
              <ListItemIcon><LocalShippingIcon sx={{ color: '#fff' }} /></ListItemIcon>
              <ListItemText primary="Domicilios" />
              {openDomicilio ? <ExpandLess sx={{ color: '#fff' }} /> : <ExpandMore sx={{ color: '#fff' }} />}
            </ListItemButton>
            <Collapse in={openDomicilio} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/logistica-domicilio">
                    <ListItemIcon><Assignment sx={{ color: '#fff' }} /></ListItemIcon>
                    <ListItemText primary="Logistica domicilios" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/configuracion-domicilio">
                    <ListItemIcon><Assignment sx={{ color: '#fff' }} /></ListItemIcon>
                    <ListItemText primary="Configuracion domicilios" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/ruta-programada">
                    <ListItemIcon><Assignment sx={{ color: '#fff' }} /></ListItemIcon>
                    <ListItemText primary="Ruta programada" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Collapse>

            {/* Recepcion Colas */}
            <ListItemButton onClick={() => setOpenRecepcion(!openRecepcion)}>
              <ListItemIcon><TimerIcon sx={{ color: '#fff' }} /></ListItemIcon>
              <ListItemText primary="Recepcion Colas" />
              {openRecepcion ? <ExpandLess sx={{ color: '#fff' }} /> : <ExpandMore sx={{ color: '#fff' }} />}
            </ListItemButton>
            <Collapse in={openRecepcion} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/recepcion-panel">
                    <ListItemIcon><Assignment sx={{ color: '#fff' }} /></ListItemIcon>
                    <ListItemText primary="Recepcion Panel" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/recepcion-escanner">
                    <ListItemIcon><Assignment sx={{ color: '#fff' }} /></ListItemIcon>
                    <ListItemText primary="Recepcion Escanner" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/cola-consultorio-servicio">
                    <ListItemIcon><Assignment sx={{ color: '#fff' }} /></ListItemIcon>
                    <ListItemText primary="Ver pantalla cola" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Collapse>

            {/* Ubicaciones */}
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/ubicaciones">
                <ListItemIcon><LocationOnIcon sx={{ color: '#fff' }} /></ListItemIcon>
                <ListItemText primary="Ubicaciones en Clinica" />
              </ListItemButton>
            </ListItem>

            <Divider sx={{ bgcolor: '#4b5563', my: 1 }} />

            {/* Configuraciones */}
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/configuraciones">
                <ListItemIcon><BuildIcon sx={{ color: '#94a3b8' }} /></ListItemIcon>
                <ListItemText
                  primary="Configuraciones"
                  primaryTypographyProps={{ sx: { color: '#94a3b8', fontSize: '0.875rem' } }}
                />
              </ListItemButton>
            </ListItem>
          </>
        )}

      </List>

      <BuscarPacienteModal
        open={openBuscarPaciente}
        handleClose={() => setOpenBuscarPaciente(false)}
        navigate={navigate}
      />
    </Drawer>
  );
};

export default Sidebar;